import { Injectable, OnDestroy } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CopDecimalCalculateService implements OnDestroy {
  against = "D";

  constructor(
    private snackBar:MatSnackBar
  ) {}

  protected _onDestroy = new Subject<void>();

  /**
   *Destroy Method
   *
   * @memberof CopDecimalCalculateService
   */
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  /**
   * decimal point upto 2 decimal
   * @memberof CopDecimalCalculateService
   */

  toFixedUptoTwoDecimal(data) {
    return data.toFixed(2);
  }

  /**
   * decimal point upto 4 decimal
   * @memberof CopDecimalCalculateService
   */

  toFixedUptoFourDecimal(data) {
    if (!data || isNaN(data)) {
      return '0.0000';
    } else {
      return data.toFixed(4);
    }
  }

  roundTo(value: unknown, decimals: number): number {
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;

    const factor = 10 ** decimals;
    return Math.round((num + Number.EPSILON) * factor) / factor;
  }

  /**
   * to calculate original cop against uom type
   * @memberof CopDecimalCalculateService
   * @param selectedUom 
   * @param element 
   * @returns 
   */

  toCalculateCOPAgainstUOM(selectedUom: any, element: any) {
    let conversionPurchase = 0;
    let conversionStock = 0;
    let conversionDispense = 0;
    if (selectedUom) {
      (element.uom || element.uomList || element.uomResponseList).map((data) => {
        if (data.uomTypeId == "1") {
          conversionPurchase = data.conversion;
        } else if (data.uomTypeId == "2") {
          conversionStock = data.conversion;
        } else if (data.uomTypeId == "3") {
          conversionDispense = data.conversion;
        }
      });
      let cop = element.costPrice > 0 ? element.costPrice : element.cop || 0;
      if (selectedUom.uomTypeId == "1") {
        let data = cop > 0 ? 
          (element.costPrice ? element.costPrice : element.cop) *
          conversionPurchase *
          conversionStock *
          conversionDispense : 0;
        return (element.calculatedCostPrice =
          this.toFixedUptoFourDecimal(data));
      } else if (selectedUom.uomTypeId == "2") {
        let data = cop > 0 ? (element.costPrice ? element.costPrice : element.cop) * conversionStock * conversionDispense : 0;
        return (element.calculatedCostPrice =
          this.toFixedUptoFourDecimal(data));
      } else {
        let data = cop > 0 ? (element.costPrice ? element.costPrice : element.cop) * conversionDispense : 0;
        return (element.calculatedCostPrice =
          this.toFixedUptoFourDecimal(data));
      }
    }
  }

  /**
   * to calculate cop against uom type and also calculate cop when I manually enter cop amount for
   * any particular uom type then accordingly changed to remaining uom types
   * @param element
   * @param uomTypeIdForCalculateRate
   * @returns
   */
  toCalculateRateUom(element: any, uomTypeIdForCalculateRate: string) {
    if (this.against == "D") {
      let conversionPurchase = 0;
      let conversionStock = 0;
      let conversionDispense = 0;
      if (element.selectedUom) {
        (element.uom || element.uomList || element.uomResponseList).map((data) => {
          if (data.uomTypeId == "1") {
            conversionPurchase = data.conversion;
          } else if (data.uomTypeId == "2") {
            conversionStock = data.conversion;
          } else if (data.uomTypeId == "3") {
            conversionDispense = data.conversion;
          }
        });
        if (element.rate) {
          if (uomTypeIdForCalculateRate == "1") {
            if (element.selectedUom.uomTypeId == "3") {
              let data =
                element.rate /
                conversionPurchase /
                conversionStock /
                conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity * conversionPurchase * conversionStock * conversionDispense) : 0;
            } else if (element.selectedUom.uomTypeId == "2") {
              let data = element.rate / conversionPurchase / conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity * conversionStock * conversionDispense) : 0;
            } else {
              let data = element.rate / conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity * conversionDispense) : 0;
            }
            // Calculate copAmount
            element.copAmount =
              (element.quantity ? element.quantity : (element.poQuantity ? element.poQuantity : (element.poquantity ? element.poquantity : element.returnQty || 0))) * (element.cop ? element.cop : 0);
            element.copAmount = this.toFixedUptoTwoDecimal(element.copAmount);
            element.totalAmount = element.copAmount > 0 ? element.copAmount : "0.00";
            element.purchaseTotalAmount = element.copAmount > 0 ? element.copAmount : "0.00";
            // Calculate discountAmt first
            element.discountAmt = element.discountPercent
              ? this.toFixedUptoTwoDecimal((parseFloat(element.purchaseTotalAmount ? element.purchaseTotalAmount : 0) * parseFloat(element.discountPercent)) / 100)
              : 0;
            // Calculate taxAmount on (copAmount - discountAmt)
            const taxableAmount = parseFloat(element.copAmount) - parseFloat(element.discountAmt);
            element.taxAmount = this.toFixedUptoTwoDecimal(
              (taxableAmount / 100) * (element.taxPercent ? element.taxPercent : (element.selectedTax ? element.selectedTax.percentage : element.taxPercentage))
            );
            element.taxAmount = element.taxAmount > 0 ? element.taxAmount : "0.00";
            // Calculate netAmount as (copAmount - discountAmt + taxAmount)
            element.netAmount = this.toFixedUptoTwoDecimal(
              taxableAmount + parseFloat(element.taxAmount)
            );
            element.netAmount = element.netAmount > 0 ? element.netAmount : "0.00";
            return (
              element.cop,
              element.calculatePendingQuantity,
              element.copAmount,
              element.totalAmount,
              element.purchaseTotalAmount,
              element.discountAmt,
              element.taxAmount,
              element.netAmount
            );
          } else if (uomTypeIdForCalculateRate == "2") {
            if (element.selectedUom.uomTypeId == "3") {
              let data = element.rate / conversionStock / conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity * conversionStock * conversionDispense) : 0;
            } else if (element.selectedUom.uomTypeId == "2") {
              let data = element.rate / conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity * conversionDispense) : 0;
            } else {
              let data = element.rate * conversionPurchase * conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity / conversionPurchase / conversionDispense) : 0;
            }
            // Calculate copAmount
            element.copAmount =
              (element.quantity ? element.quantity : (element.poQuantity ? element.poQuantity : (element.poquantity ? element.poquantity : element.returnQty || 0))) * (element.cop ? element.cop : 0);
            element.copAmount = this.toFixedUptoTwoDecimal(element.copAmount);
            element.totalAmount = element.copAmount > 0 ? element.copAmount : "0.00";
            element.purchaseTotalAmount = element.copAmount > 0 ? element.copAmount : "0.00";
            // Calculate discountAmt first
            element.discountAmt = element.discountPercent
              ? this.toFixedUptoTwoDecimal((parseFloat(element.purchaseTotalAmount ? element.purchaseTotalAmount : 0) * parseFloat(element.discountPercent)) / 100)
              : 0;
            // Calculate taxAmount on (copAmount - discountAmt)
            const taxableAmount = parseFloat(element.copAmount) - parseFloat(element.discountAmt);
            element.taxAmount = this.toFixedUptoTwoDecimal(
              (taxableAmount / 100) * (element.taxPercent ? element.taxPercent : (element.selectedTax ? element.selectedTax.percentage : element.taxPercentage))
            );
            element.taxAmount = element.taxAmount > 0 ? element.taxAmount : "0.00";
            // Calculate netAmount as (copAmount - discountAmt + taxAmount)
            element.netAmount = this.toFixedUptoTwoDecimal(
              taxableAmount + parseFloat(element.taxAmount)
            );
            element.netAmount = element.netAmount > 0 ? element.netAmount : "0.00";
            return (
              element.cop,
              element.calculatePendingQuantity,
              element.copAmount,
              element.totalAmount,
              element.purchaseTotalAmount,
              element.discountAmt,
              element.taxAmount,
              element.netAmount
            );
          } else {
            if (element.selectedUom.uomTypeId == "1") {
              let data =
                element.rate *
                conversionPurchase *
                conversionStock *
                conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity / conversionPurchase / conversionStock / conversionDispense) : 0;
            } else if (element.selectedUom.uomTypeId == "2") {
              let data = element.rate * conversionStock * conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity / conversionStock / conversionDispense) : 0;
            } else {
              let data = element.rate * conversionDispense;
              element.cop = this.toFixedUptoFourDecimal(data);
              element.calculatePendingQuantity = element.pendingQuantity != undefined ? (element.pendingQuantity / conversionDispense) : 0;
            }
            // Calculate copAmount
            element.copAmount =
              (element.quantity ? element.quantity : (element.poQuantity ? element.poQuantity : (element.poquantity ? element.poquantity : element.returnQty || 0))) * (element.cop ? element.cop : 0);
            element.copAmount = this.toFixedUptoTwoDecimal(element.copAmount);
            element.totalAmount = element.copAmount > 0 ? element.copAmount : "0.00";
            element.purchaseTotalAmount = element.copAmount > 0 ? element.copAmount : "0.00";
            // Calculate discountAmt first
            element.discountAmt = element.discountPercent
              ? this.toFixedUptoTwoDecimal((parseFloat(element.purchaseTotalAmount ? element.purchaseTotalAmount : 0) * parseFloat(element.discountPercent)) / 100)
              : 0;
            // Calculate taxAmount on (copAmount - discountAmt)
            const taxableAmount = parseFloat(element.copAmount) - parseFloat(element.discountAmt);
            element.taxAmount = this.toFixedUptoTwoDecimal(
              (taxableAmount / 100) * (element.taxPercent ? element.taxPercent : (element.selectedTax ? element.selectedTax.percentage : element.taxPercentage))
            );
            element.taxAmount = element.taxAmount > 0 ? element.taxAmount : "0.00";
            // Calculate netAmount as (copAmount - discountAmt + taxAmount)
            element.netAmount = this.toFixedUptoTwoDecimal(
              taxableAmount + parseFloat(element.taxAmount)
            );
            element.netAmount = element.netAmount > 0 ? element.netAmount : "0.00";
            return (
              element.cop,
              element.calculatePendingQuantity,
              element.copAmount,
              element.totalAmount,
              element.purchaseTotalAmount,
              element.discountAmt,
              element.taxAmount,
              element.netAmount
            );
          }
        }
      }
    }
  }
/**
 * 
 * @param data 
 * @returns 
 */
  handleNumberFormatting(data) {
    if (!data || isNaN(data) || data === 0 || data === '0' || data === '0.00' || data == undefined || data == null) {
      return '0.00';
    }
    const decimalCount = data.toString().split(".")[1]?.length || 0;
  
    if (decimalCount === 2) {
      return Number(data).toFixed(2);
    } else if (decimalCount >= 4) {
      return Number(data).toFixed(4);
    } else {
      return Number(data).toFixed(2);
    }
  }
  /**
   *check number input length limit
   *
   * @param {Event} event
   * @param {number} maxLength
   * @memberof CopDecimalCalculateService
   */
  limitInputLength(event: Event, maxLength: number): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.slice(0, maxLength);
  }
  replaceSpaces(event: any) {
    const inputValue = event.target.value;
    const replacedValue = inputValue.replace(/\s+/g, ''); // replace one or more spaces with empty string
    event.target.value = replacedValue;
  }
  /**
     * Method to format the input value to two decimal places
     * @param event 
     */  
  formatToTwoDecimalPlaces(event: any): void {
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, '');
  
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1]; 
    }
    if (parts[1] && parts[1].length > 2) {
      value = `${parts[0]}.${parts[1].substring(0, 2)}`;
    }
    const numericValue = parseFloat(value);
    if (numericValue < 0) {
      value = '0.00';
    }
    event.target.value = value;
  }

  /**
   * to check enter quantity is greater or not than Available Stock
   * @param event 
   * @param stockQty 
   */
  formatToQtyValidate(event, stockQty) {
    let value =event && event.target ? event.target.value : event;
    if(value){
    let decimalValue = parseFloat(value);
  
    if (value === '' || value === '0' || decimalValue > stockQty || value < 0) {
      value = '';
      this.snackBar.open("Info", "Please enter Quantity less than or equal to Stock Available Quantity", {
        duration: 2000,
      });
    } else if (decimalValue < stockQty && value.includes('.')) {
      let decimalPlaces = value.split('.')[1].length;
      if (decimalPlaces > 2) {
        value = value.substring(0, value.indexOf('.') + 3);
      }
    }
  }
    if (event && event.target) {
      event.target.value = value;
    }
    return value;
  }


  /**
 * 
 * @param data 
 * @returns 
 */
  handleNumbersFormatting(data) {
    if (!data || isNaN(data) || data === 0 || data === '0' || data === '0.00' || data == undefined || data == null) {
      return '0.00';
    }
    const decimalCount = data.toString().split(".")[1]?.length || 0;
  
    if (decimalCount === 2 || decimalCount >= 4) {
      return Number(data).toFixed(2);
    } else {
      return data;
    }
  }

  formatString(value: string): string {
    if (!value) return '';
    let limit = 30;
    let lines = 3;
 
    const maxLength = limit * lines; // Total characters allowed before adding '...'
    if (value.length <= maxLength) return value;
 
    const truncated = value.substring(0, maxLength); // Take up to the limit
    const formatted: string[] = [];
 

    for (let i = 0; i < truncated.length; i += limit) {
      formatted.push(truncated.substring(i, i + limit)); // Split into chunks of limit
    }
 

    return formatted.slice(0, lines).join('\n') + '...'; // Join lines with \n and append '...'
  }

/**
* 
* @param data 
* @returns 
*/
  handleNumberDecimal(data) {
    const decimalCount = data.toString().split(".")[1]?.length || 0;
  
    if (decimalCount >= 2) {
      return Number(Math.round(data * 10) / 10).toFixed(1); 
    } else {
      return data;
    }
  }
  
  handleStockFormatting(data) {  
    if (!data || isNaN(data) || data === 0 || data === '0' || data === '0.00' || data == undefined || data == null) {
      return '0.00';
    }
    const numberValue = Number(data); 
    const decimalCount = (data.toString().split(".")[1]?.length || 0); 

    // Check if the value is a whole number  
    if (Number.isInteger(numberValue)) {  
        return numberValue.toString();
    }  

    // Handle cases with decimal values  
    if (decimalCount === 1) {  
        return numberValue.toFixed(1).replace(/\.0$/, '') 
    } else if (decimalCount === 2) {  
        return numberValue.toFixed(2);
    } else if (decimalCount > 2) {  
        return numberValue.toFixed(2);
    }  

    // If none of the conditions are met, return the original data  
    return data;  
}
/**
 * to validate manually entered expiry date for row wise record
 * @param element 
 * @param index 
 */
validateExpiry(element: any, index): void {
  const currentDate = new Date();
  const enteredDate = new Date(element.expiryDate ? element.expiryDate : element.expectedDate._d);
  // Strip the time part from both dates
  currentDate.setHours(0, 0, 0, 0);
  enteredDate.setHours(0, 0, 0, 0);
  if (enteredDate < currentDate) {
    element.expiryDate = null; // Clear the date if it's in the past
    element.expectedDate = null; // Clear the date if it's in the past
    this.snackBar.open('The entered date is in the past. Please enter a valid date.', 'Error', {
      duration: 3000,
    });
    element.selectedRow = index;
  } 
}
/**
 * to check manually entered expected date is in past or not
 * @param event 
 * @param dateProperty 
 * @param component 
 */
onDateChange(event: any, dateProperty: string, component: any): void {
  const currentDate = new Date();
  const enteredDate = new Date(event.value);
  // Strip the time part from both dates
  currentDate.setHours(0, 0, 0, 0);
  enteredDate.setHours(0, 0, 0, 0);
  if (enteredDate < currentDate) {
    this.snackBar.open('The entered date is in the past. Please enter a valid date.', 'Error', {
      duration: 3000,
    });
    // Clear the date if it's in the past
    component[dateProperty] = null;
  }
}
/**
 * to check from date and to date
 * @param event 
 * @param value 
 */
onDateSelect(event: any, dateProperty: string, component: any): void {
  const currentDate = new Date();
  const enteredDate = new Date(event.value);
  // Strip the time part from both dates
  currentDate.setHours(0, 0, 0, 0);
  enteredDate.setHours(0, 0, 0, 0);
  if (event.value == null) {
    this.snackBar.open('The entered value is not a valid date. Please enter a valid date.', 'Error', {
      duration: 3000,
    });
    // Clear the date if it's not a valid date
    component[dateProperty] = "";
  } else if (enteredDate < currentDate) {
    this.snackBar.open('The entered date is in the past. Please enter a valid date.', 'Error', {
      duration: 3000,
    });
    component[dateProperty] = null;
  } else if (dateProperty === 'validityEnd' && enteredDate < component.validityStart) {
    this.snackBar.open('Validity End date cannot be before Validity Start date.', 'Error', {
      duration: 3000,
    });
    component[dateProperty] = null;
  }
}
}